import { Typography } from "antd";

const Policy = () => {
  return (
    <>
      <div className="features" id="about">
        <div className="header-text">Our Privacy Policy</div>
        <div>
          <Typography.Text className="privacy-text">
            At HaveTo (haveto.com), we are committed to protecting the privacy
            and security of our users' personal information. This Privacy Policy
            describes how we collect, use, share, and safeguard the personal
            data you provide when you use our website, products, and services.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            1. Information We Collect We collect personal information that you
            voluntarily provide to us, such as when you:
            <br />
            Sign up for our services Contact us for support or inquiries
            Participate in promotions or surveys This information may include
            your name, email address, phone number, and any other details
            necessary for us to serve you better.
          </Typography.Text>
          <br />
          <br />
        </div>
        <div>
          <Typography.Text className="privacy-text">
            2. How We Use Your Information We use the information we collect to:
            <br />
            Provide and improve our products and services Communicate with you
            about your account or our offerings Send promotional emails or
            updates (you may opt out at any time) Enhance your experience on our
            platform.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            3. Sharing Your Information We do not sell or rent your personal
            information. We may share it only with:
            <br />
            Trusted third-party service providers who help us operate our
            website and services Legal or regulatory bodies, if required by law
            or to protect our rights All third-party partners are bound by
            confidentiality and data protection agreements.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            4. Data Security We implement industry-standard security measures to
            protect your personal data from unauthorized access, disclosure,
            alteration, or destruction. These include:
            <br />
            Encryption and secure data transmission Regular security audits
            Access controls and employee training.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            5. Data Retention We retain your personal information only for as
            long as necessary to:
            <br />
            Fulfill the purposes for which it was collected Comply with
            applicable legal, tax, or regulatory obligations.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            6. Your Rights You have the right to:
            <br />
            Access the personal data we
            hold about you Request corrections or updates Ask us to delete your
            information, subject to legal limitations To exercise your rights,
            please contact us at contact@haveto.com.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            7. Changes to This Policy We may update this Privacy Policy from
            time to time. If we make significant changes, we will post the
            revised policy on our website and update the "Effective Date".
            Continued use of our services constitutes acceptance of those
            changes.
          </Typography.Text>
          <br />
          <br />
          <Typography.Text className="privacy-text">
            8. Contact Us If you have any questions, concerns, or requests
            regarding this Privacy Policy or our data practices, feel free to
            contact us at: contact@haveto.com
          </Typography.Text>
          <br />
          <br />
          <br />
        </div>
      </div>
    </>
  );
};

export default Policy;
